import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  }
  // {
  //   path: '/catalog',
  //   name: 'catalog-view',
  //   component: () => import(/* webpackChunkName: "catalog" */ '../views/Catalog.vue')
  // },
  // {
  //   path: '/resources',
  //   name: 'resources-view',
  //   component: () => import(/* webpackChunkName: "resources" */ '../views/Resources.vue')
  // },
  // {
  //   path: '/apps',
  //   name: 'apps-view',
  //   component: () => import(/* webpackChunkName: "apps" */ '../views/Apps.vue')
  // },
  // {
  //   path: '/inventory',
  //   name: 'inventory-view',
  //   component: () => import(/* webpackChunkName: "inventory" */ '../views/Inventory.vue')
  // },
  // {
  //   path: '/item/:id',
  //   name: 'product-page',
  //   component: () => import(/* webpackChunkName: "resourcepage" */ '../views/ResourcePage.vue')
  // },
  // {
  //   path: '/category/:id',
  //   name: 'category-view',
  //   component: () => import(/* webpackChunkName: "resourcepage" */ '../views/ResourcePage.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
